import axios from 'axios'
import { Toast, Dialog } from 'vant';
import { paramsToFormData } from '@/utils/custom';

// 创建axios实例
const service = axios.create({
  baseURL: 'https://apos.mk-dz.com/sfb-api/',
  timeout: 600000
})
// 参数拼接
var parseParam=function(param, key){
	var paramStr="";
	Object.keys(param).forEach(function(item){
		paramStr += "&"+item+"="+encodeURIComponent(param[item])
	})
	return paramStr.substr(1);
};
// request拦截器
service.interceptors.request.use(config => {
  // 加载等待
  const toast = Toast.loading({
    forbidClick: true,
    message: '加载中...',
    duration: 0
  });
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof(value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if(config.method === 'post'){
    if(!config.data.specialType){
      // 数据处理 => 重构 DATA 内容
      let newData = {};
      newData.encrypted = 'Y';
      newData.data = config.data ? parseParam(config.data) : '';
      // 数据加密
      var NodeRSA = require('node-rsa');
      // 公钥
      var publiukey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCIM9eAcO39UYyTr3MDiUPwfswdhniTwVcGhs8GUhq6BkPRzZE7NQZ1J3d8xez2lK+21yPmvh13OAxvm9lFtpyGNULW7R1pacoYK7bsKQTy9YPY/S7ZNs3Eoscli3LPWyoI+QtDbk5aZy8oOJzGCk15kpd5ZODTMz/uMF0lWs/f5wIDAQAB';
      // 导入公钥
      var pubKey = new NodeRSA(publiukey,'pkcs8-public');
      //适配Java解密
      pubKey.setOptions({encryptionScheme: 'pkcs1'});
      // base64 加密
      var encrypted = pubKey.encrypt(newData.data, 'base64');
      // 参数重定义
      newData.data = encrypted;
      config.data = paramsToFormData(newData);
    } else {
      // 活体加密 安卓异常 浏览器卡死 暂去除加密
      config.data = paramsToFormData(config.data)
    }
  }
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    Toast.clear();
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    if(code == '1'){
      Dialog.alert({
        title: '重新登录',
        message: '登录状态已过期，您可以继续留在该页面，或者重新登录',
      }).then(() => {
        localStorage.clear();
        location.href = '/sfb/login';
      })
      return Promise.reject('error')
    } else if(code == '500') {
      // 异常抛出
      Toast(res.data.msg)
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Toast(message)
    return Promise.reject(error)
  }
)

export default service
